/*
  stic-cart.js, cart order bump.

  Deliberately narrow in scope: it adds one configured product to the cart and then
  hands rendering back to the theme's own cart implementation (cart-drawer,
  cart-notification, or a cart-page reload). It never keeps its own cart state and
  never computes prices or discounts.

  The free-shipping meter needs no JavaScript: it is rendered by Liquid inside regions
  the theme already re-renders after every cart mutation (drawer inner, cart-page
  .js-contents, cart-notification button section).
*/
(function () {
  'use strict';

  const SELECTOR = '[data-stic-bump]';

  function announce(root, message) {
    const live = root.querySelector('[data-stic-bump-live]');
    if (live) live.textContent = message;
  }

  function showError(root, message) {
    const error = root.querySelector('[data-stic-bump-error]');
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  }

  function cartSurface() {
    // The drawer is injected on every template, /cart included, so it cannot be
    // used to detect the surface. On the cart page the page itself is the cart
    // and must be re-rendered by the server; rendering into the drawer there
    // would slide a fresh drawer over a stale page and leave this button
    // aria-disabled with nothing to re-enable it.
    if (document.querySelector('cart-items')) return null;
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function onClick(event) {
    const button = event.target.closest('[data-stic-bump-add]');
    if (!button) return;

    const root = button.closest(SELECTOR);
    if (!root || button.getAttribute('aria-disabled') === 'true') return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    event.preventDefault();
    button.setAttribute('aria-disabled', 'true');
    showError(root, '');

    const surface = cartSurface();
    const body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');

    if (surface && typeof surface.getSectionsToRender === 'function') {
      body.append('sections', surface.getSectionsToRender().map((section) => section.id).join(','));
      body.append('sections_url', window.location.pathname);
      if (typeof surface.setActiveElement === 'function') surface.setActiveElement(button);
    }

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body,
    })
      .then((response) => {
        // Without an explicit failure the button stays aria-disabled forever on
        // a stalled connection, with no message and no way to retry. 422 is a
        // real cart response and must still be parsed.
        if (!response.ok && response.status !== 422) throw new Error(response.status);
        return response.json();
      })
      .then((state) => {
        if (state.status) {
          showError(root, state.description || state.message || window.cartStrings.error);
          button.removeAttribute('aria-disabled');
          return;
        }

        announce(root, root.dataset.addedMessage || '');

        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'stic-cart-order-bump',
            productVariantId: variantId,
            cartData: state,
          });
        }

        if (surface && typeof surface.renderContents === 'function') {
          surface.renderContents(state);
        } else {
          // Cart page: let the server re-render the whole cart truthfully.
          window.location.reload();
        }
      })
      .catch(() => {
        showError(root, window.cartStrings ? window.cartStrings.error : '');
        button.removeAttribute('aria-disabled');
      });
  }

  // Delegated so it survives cart sections being re-rendered.
  document.addEventListener('click', onClick);
})();
